'use strict';

var messages = require('./messages.json');
var regexMap = require('./constants').regexMap;

var defaultOptions = {
    allowPOBox: false,
    allowLongUSZipCode: true,
    isPhoneRequired: true
};

var rules = {
    firstName: function (address) {
        return [{
            isValid: !regexMap.specialCharacters.test(address.firstName),
            message: messages.specialCharactersShort
        }];
    },
    lastName: function (address) {
        return [{
            isValid: !regexMap.specialCharacters.test(address.lastName),
            message: messages.specialCharactersShort
        }];
    },
    country: function (address) {
        return [{
            isValid: !regexMap.specialCharacters.test(address.country),
            message: messages.specialCharacters
        }];
    },
    line1: function (address, options) {
        return [{
            isValid: !regexMap.specialCharactersAddress.test(address.line1),
            message: messages.specialCharactersAddress
        }, {
            isValid: !regexMap[options.allowPOBox ? 'all' : 'poBox'].test(address.line1),
            message: messages[options.allowPOBox ? '' : 'poBox']
        }];
    },
    line2: function (address, options) {
        return [{
            isValid: !regexMap.specialCharactersAddress.test(address.line2),
            message: messages.specialCharactersAddress
        }, {
            isValid: !regexMap[options.allowPOBox ? 'all' : 'poBox'].test(address.line2),
            message: messages[options.allowPOBox ? '' : 'poBox']
        }];
    },
    city: function (address) {
        return [{
            isValid: !regexMap.specialCharacters.test(address.city),
            message: messages.specialCharactersShort
        }];
    },
    state: function (address) {
        return [{
            isValid: !regexMap.specialCharacters.test(address.state),
            message: messages.specialCharactersAddress
        }];
    },
    zipCode: function (address, options) {
        return [{
            isValid: !regexMap[options.isCountryUS ? (options.allowLongUSZipCode ? 'usZipCode' : 'usZipCodeShort') : 'globalZipCode'].test(address.zipCode),
            message: messages[options.isCountryUS ? (options.allowLongUSZipCode ? 'usZipCodeShipping' : 'usZipCodeShort') : 'globalZipCode']
        }];
    }
};

module.exports = {
    defaultOptions: defaultOptions,
    rules: rules
};



//////////////////
// WEBPACK FOOTER
// ./~/dibs-address-validator/validation.js
// module id = 843
// module chunks = 4 7 13 14 20